/*
 * @Description: vuex 仓库
 * @Author: 王振
 * @Date: 2021-07-06 16:19:41
 * @LastEditors: 王振
 * @LastEditTime: 2021-07-06 16:50:03
 */
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import user from "./modules/user";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
  },
  getters,
});

export default store;



// WEBPACK FOOTER //
// ./src/pages/system/store/index.js